import { render, staticRenderFns } from "./mucModuleDataMgmt.vue?vue&type=template&id=8c714664"
import script from "./mucModuleDataMgmt.vue?vue&type=script&lang=js"
export * from "./mucModuleDataMgmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports